<template>
  <div class="bg">
    <div class="login-panel">
      <span class="title">欢迎登陆八爪鱼客户管理系统</span>
      <v-container fluid grid-list-md class="xn-form pa-0">
        <form v-if="!showNext" @submit.prevent="next">
          <v-flex xs12>
            <v-text-field
              v-model="username"
              label="请输入账号"
              name="username"
              outline
              solo
            ></v-text-field>
          </v-flex>
          <v-flex xs12 style="display: flex;align-items: center;justify-content: left">
            <v-radio-group v-model="item.type" row>
              <v-radio label="邮箱接收验证码" value="email"></v-radio>
              <v-radio label="短信接收验证码" value="sms"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12>
            <div ref="vaptcha1" style="width: 300px;height: 36px;">
              <div class="vaptcha-init-main">
                <div class="vaptcha-init-loading">
                  <a href="/" target="_blank">
                    <img src="https://r.vaptcha.com/public/img/vaptcha-loading.gif" />
                  </a>
                  <span class="vaptcha-text">Vaptcha启动中...</span>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-btn color="info" block type="submit" :disabled="!btnNextDisabled">下一步</v-btn>
          </v-flex>
        </form>
        <form v-else @submit.prevent="resetPwd">
          <v-flex xs12>
            <v-text-field
              v-model="item.code"
              label="请输入验证码"
              name="item.code"
              outline
              solo
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="item.password"
              label="请输入密码"
              name="item.password"
              hint="长度至少为8"
              type="password"
              outline
              solo
            ></v-text-field>
          </v-flex>
          <v-flex v-if="showVaptcha2" xs12>
            <div ref="vaptcha2" style="width: 300px;height: 36px;">
              <div class="vaptcha-init-main">
                <div class="vaptcha-init-loading">
                  <a href="/" target="_blank">
                    <img src="https://r.vaptcha.com/public/img/vaptcha-loading.gif" />
                  </a>
                  <span class="vaptcha-text">Vaptcha启动中...</span>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-btn color="info" block type="submit" :disabled="!btnResetDisabled">重置密码</v-btn>
          </v-flex>
        </form>

        <v-btn style="margin-top:15px !important;" flat @click="btnForgetClicked">{{ btnForgetText }}</v-btn>
      </v-container>

      <v-snackbar
        v-if="showError"
        v-model="showError"
        :timeout="5000"
        :top="true"
        :multi-line="false"
        :vertical="false"
      >
        {{ text }}
        <v-btn
          class="pink--text"
          flat
          @click.native="showError = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </div>

    <p class="beian">津ICP备19005910号-1</p>
  </div>
</template>

<script>
  import axios from "../axios";

  export default {
    name: 'ResetPasswordForm',
    computed: {
      btnNextDisabled() {
        return this.username !== '';
      },
      btnResetDisabled() {
        return this.item.code !== '' && this.rules.length8(this.item.password)
      }
    },
    data: () => ({
      rules: {
        length8: value => (!!value && value.length >= 8),
        phoneNumber: value => {
          const pattern = /^1\d{10}$/;
          return pattern.test(value);
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value);
        }
      },
      username: '',
      showError: false,
      text: "",
      item: {
        type:'email'
      },
      showNext: false,
      RECAPTCHA: null,
      btnForgetText: '返回登录',
      vaptchaObj1: null,
      vaptchaObj2: null,
      showVaptcha2: false
    }),
    methods: {
      btnForgetClicked() {
        this.$router.push({
          name: 'login'
        });
      },
      next() {
        let response = this.vaptchaObj1.getToken();

        if (response && response !== '') {
          axios
            .post("/users/" + this.username + "/password", this.item, {
              headers: {
                'g-recaptcha-response': response
              },
              withCredentials: true
            })
            .then(response => {
              this.showNext = true;
            })
            .catch((reason) => {
              this.vaptchaObj1.reset();
              this.showError = true;
              this.text = reason.response.data.message;
            });
        } else {
          this.showError = true;
          this.text = '验证有误';
        }
      },
      renderGrecaptcha() {
        window.vaptcha({
          vid: '5df151acca7dd34ba15499d6',
          type: 'click',
          scene: '2',
          container: this.$refs.vaptcha1,
          offline_server: process.env.VUE_APP_API + 'vaptcha/offline'
        }).then(obj => {
          obj.render();
          this.vaptchaObj1 = obj;
        });

      },
      resetPwd() {
        let header = null;
        if (this.RECAPTCHA === 'RECAPTCHA') {
          let response = this.vaptchaObj2.getToken();
          header = {
            headers: {
              'g-recaptcha-response': response
            },
            withCredentials: true
          };

          if (response && response !== '') {
            //可以继续
          } else {
            this.showError = true;
            this.text = '验证有误';
            return;
          }
        }

        axios
          .post("/users/" + this.username + "/password", this.item, header)
          .then(response => {
            this.RECAPTCHA = null;
            this.$router.push({
              name: 'login',
              params: {message: '重置密码成功'}
            });
          })
          .catch((reason) => {
            if (reason.response.data.message === 'RECAPTCHA') {
              //加验证
              this.showVaptcha2 = true;
              this.RECAPTCHA = 'RECAPTCHA';
              setTimeout(() => {
                window.vaptcha({
                  vid: '5df151acca7dd34ba15499d6',
                  type: 'click',
                  scene: '2',
                  container: this.$refs.vaptcha2,
                  offline_server: process.env.VUE_APP_API + 'vaptcha/offline'
                }).then(obj => {
                  obj.render();
                  this.vaptchaObj2 = obj;
                });
              }, 1000);
            }
            this.showError = true;
            this.text = '验证有误';
          });
      }
    },
    mounted() {
      this.renderGrecaptcha();
    }
  }
</script>

<style scoped>
  .bg {
    background: url('../assets/bg.png');
    background-size: cover;
    width: 100%;
    height: 100%;
  }
  .beian{
    position: fixed;
    background: rgba(0,0,0,0.8);
    color:#ccc;
    bottom: 0;
    width:100%;
    display: block;
    margin:0;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
  }

  .login-panel {
    width: 394px;
    height: 402px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    position: absolute;
    top: 50%;
    margin-top: -201px;
    right: 248px;
    padding: 35px 46px;
  }

  .title {
    font-weight: 400;
    color: rgba(32, 133, 245, 1);
    line-height: 30px;
    margin-bottom: 32px;
    text-align: justify;
    text-justify: distribute-all-lines; /*ie6-8*/
    text-align-last: justify; /* ie9*/
    -moz-text-align-last: justify; /*ff*/
    -webkit-text-align-last: justify; /*chrome 20+*/
    width: 100%;
    display: block;
  }

  .code {
    text-transform: lowercase;
  }

  @media screen and (max-width: 1000px) {
    .login-panel {
      margin-right: -197px;
      right: 50%;
    }
  }

  form {
    width: 100%;
  }

  .vaptcha-init-main {
    display: table;
    width: 100%;
    height: 100%;
    background-color: #EEEEEE;
  }

  .vaptcha-init-loading {
    display: table-cell;
    vertical-align: middle;
    text-align: center
  }

  .vaptcha-init-loading>a {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: none;
  }

  .vaptcha-init-loading>a img {
    vertical-align: middle
  }

  .vaptcha-init-loading .vaptcha-text {
    font-family: sans-serif;
    font-size: 12px;
    color: #CCCCCC;
    vertical-align: middle
  }
</style>
